import { TYPE_INVESTOR, TYPE_ADMIN } from "../api/constants";
import useAuth from "../hooks/useAuth";

export const IsSuperUser = () => {
  const { user } = useAuth();  
  return user?.is_superuser || false
}